<template>
<div class="chapter">
<div class="inner_page">
<h1 class="head1">I Am Mary Dunne</h1>
<p class="subtitle">A Novel</p>
<p class="head2">Brian Moore</p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?abce1ab6